import { render, staticRenderFns } from "./CorporationInfo1.vue?vue&type=template&id=3425a11b"
import script from "./CorporationInfo1.vue?vue&type=script&lang=js"
export * from "./CorporationInfo1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3425a11b')) {
      api.createRecord('3425a11b', component.options)
    } else {
      api.reload('3425a11b', component.options)
    }
    module.hot.accept("./CorporationInfo1.vue?vue&type=template&id=3425a11b", function () {
      api.rerender('3425a11b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/CorporationInfo1.vue"
export default component.exports